<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
    <g clip-path="url(#clip0_37112_40313)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30 15C30 23.2838 23.2838 30 15 30C6.71625 30 0 23.2838 0 15C0 6.71625 6.71625 0 15 0C23.2838 0 30 6.71625 30 15ZM15.5375 11.0738C14.0788 11.68 11.1625 12.9362 6.79 14.8413C6.08 15.1237 5.7075 15.4 5.67375 15.67C5.61625 16.1275 6.18875 16.3075 6.96625 16.5513C7.0725 16.585 7.1825 16.6187 7.295 16.6562C8.06125 16.905 9.09125 17.1962 9.62625 17.2075C10.1125 17.2175 10.655 17.0175 11.2537 16.6075C15.3387 13.8488 17.4475 12.455 17.58 12.425C17.6737 12.4037 17.8037 12.3762 17.8913 12.455C17.9788 12.5325 17.97 12.68 17.9613 12.72C17.9038 12.9612 15.6613 15.0475 14.4987 16.1275C14.1362 16.4638 13.88 16.7025 13.8275 16.7575C13.71 16.8787 13.59 16.995 13.475 17.1063C12.7625 17.7913 12.23 18.3062 13.505 19.1462C14.1175 19.55 14.6075 19.8838 15.0962 20.2163C15.63 20.58 16.1625 20.9425 16.8525 21.395C17.0275 21.51 17.195 21.6287 17.3587 21.745C17.98 22.1887 18.5387 22.5862 19.2288 22.5237C19.6287 22.4862 20.0437 22.11 20.2537 20.9862C20.75 18.3287 21.7275 12.5738 21.9538 10.2013C21.9675 10.0043 21.9591 9.80636 21.9287 9.61125C21.9106 9.45366 21.8338 9.30866 21.7138 9.205C21.535 9.05875 21.2575 9.0275 21.1325 9.03C20.5688 9.04 19.7038 9.34125 15.5375 11.0738Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_37112_40313">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts" setup>
  // Цвет прокидывается пропсом, как у IMax: на синей кнопке иконка должна быть
  // белой, а раньше цвет был зашит в разметку и она сливалась с фоном
  defineProps({
    color: {
      type: String,
      default: "#3176FF",
    },
  });
</script>
